import { useDialog } from "@platform/store";
import { AffiliationDeleteDialog } from "./AffiliationDeleteDialog";

type DialogProps = {
  isProtected?: boolean;
  affiliationName?: string;
  onConfirm?: () => void;
};

/**
 * Container for AffiliationDeleteDialog.
 * Handles dialog state from Zustand store.
 *
 * Expected dialogProps when opening:
 * - isProtected: boolean
 * - affiliationName: string
 * - onConfirm: () => void
 */
export function AffiliationDeleteDialogContainer() {
  const { activeDialog, closeDialog, dialogProps } = useDialog();

  const isOpen = activeDialog === "affiliationDelete";

  if (!isOpen) return null;

  const props = dialogProps as DialogProps | undefined;
  const isProtected = props?.isProtected ?? false;
  const affiliationName = props?.affiliationName ?? "this affiliation";
  const onConfirm = props?.onConfirm ?? (() => {});

  return (
    <AffiliationDeleteDialog
      isOpen={isOpen}
      onClose={closeDialog}
      isProtected={isProtected}
      affiliationName={affiliationName}
      onConfirm={onConfirm}
    />
  );
}

export default AffiliationDeleteDialogContainer;
